// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// require('intersection-observer')
import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'
import router from './router'
import store from './store'
import Tooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'

Vue.use(Tooltip)

// import { polyfillLoader } from 'polyfill-io-feature-detection'

// polyfillLoader({
//   'features': 'Promise',
//   'onCompleted': main
// })

// function main () {
Vue.use(VueI18n)

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
}

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: window.location.href.split(/[/?=]/).indexOf('de') > -1 ? 'de' : 'en',
  silentTranslationWarn: true,
  messages: {
    en: {
      pages: 'pages',
      articles: 'articles',
      goToBook: 'provider link',
      goToDatabase: 'provider link',
      goToOPAC: 'OPAC link',
      goToXBook: 'CrossAsia licence',
      goToXDatabase: 'CrossAsia licence',
      goToXOPAC: 'CrossAsia licence'
    },
    de: {
      pages: 'Seiten',
      articles: 'Artikel',
      goToBook: 'Anbieter Link',
      goToDatabase: 'Anbieter Link',
      goToOPAC: 'OPAC Link',
      goToXBook: 'CrossAsia Lizenz',
      goToXDatabase: 'CrossAsia Lizenz',
      goToXOPAC: 'CrossAsia Lizenz'
    }
  }
})
/* eslint-disable no-new */
window.app = new Vue({
  i18n,
  store,
  el: '#app',
  router,
  // data: {
  //   results: []
  // },
  template: '<App></App>',
  components: { App }
})
// }
// console.log(window.app)



// WEBPACK FOOTER //
// ./src/main.js